export enum RecurringUpdateType {
    ALL_OCCURRENCES = 'all-occurrences',
    CURRENT_AND_FUTURE = 'current-and-future',
    ONLY_CURRENT_OCCURRENCE = 'only-current-occurrence',
}
